import { hasRevenueAccess } from '@/utils/revenue/has-revenue-access'

/**
 * Exposes `revenueBeta` to the components that render either the redesigned
 * Revenue experience or the legacy one. It is a computed, not a constant, so
 * it re-evaluates when the user switches organization.
 */
export default {
  computed: {
    revenueBeta () {
      return hasRevenueAccess(this.$store.state.auth.account.id)
    }
  }
}
